import React from "react";
import { Pagination } from "antd";

const Pagnation = ({
  total,
  currentPage,
  pageSize,
  onPageChange,
  onPageSizeChange,
}) => (
  <Pagination
    total={total}
    current={currentPage}
    pageSize={pageSize}
    showSizeChanger
    onChange={onPageChange}
    onShowSizeChange={onPageSizeChange}
  />
);

export default Pagnation;
